/**
 * @generated SignedSource<<7a5f54903ed6509b79e3a91ce5c93013>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespDealerDetails_viewer$data = {
  readonly dealerDetailsReviewFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ContactDealerInlineForm_viewer" | "PdpRespSellerItemTileCarousel_viewer" | "PdpRespSellerItemsCarousel_viewer" | "PdpSharedDealerDetailsReviewContainerLazy_viewer" | "PdpSharedSellerTabsVariant_viewer">;
  readonly " $fragmentType": "PdpRespDealerDetails_viewer";
};
export type PdpRespDealerDetails_viewer$key = {
  readonly " $data"?: PdpRespDealerDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespDealerDetails_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "userCountryCode",
    "variableName": "userCountryCode"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasRestyledProductTiles"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespDealerDetails_viewer",
  "selections": [
    {
      "alias": "dealerDetailsReviewFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "dealerDetailsReview"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"dealerDetailsReview\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_viewer"
    },
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemTileCarousel_viewer"
        }
      ]
    },
    {
      "condition": "hasRestyledProductTiles",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": (v0/*: any*/),
          "kind": "FragmentSpread",
          "name": "PdpRespSellerItemsCarousel_viewer"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsReviewContainerLazy_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "4a07620770da6398222cfc9c3b6b2fb1";

export default node;
